import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import Icon from '@/components/Base/Icon';
import { usePageProps } from '@/hooks';

import {
  Description,
  Handler,
  IconWrapper,
  Title,
  Wrapper,
} from './NotFoundData.styles';

function NotFoundData() {
  const { location, navigate } = usePageProps();

  const buttonHandler = () => {
    navigate({
      pathname: location.pathname,
      search: '',
    });
  };

  return (
    <Wrapper>
      <IconWrapper>
        <Icon name="bigFilters" />
      </IconWrapper>

      <Title>
        <FormattedMessage id="nothingFound" />
      </Title>

      <Description>
        <FormattedMessage id="nothingFound.specifiedCriteria" />
      </Description>

      <Handler onClick={buttonHandler}>
        <FormattedMessage id="resetFilters" />
      </Handler>
    </Wrapper>
  );
}

export default memo(NotFoundData);
